import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "messageText" };
const _hoisted_2 = { class: "text-right" };
const _hoisted_3 = ["onClick"];
import MessageModal from '@/components/message/MessageModal.vue';
import useMessageThread from '@/composables/message/useMessageThread';
import useSuperAdminUser from '@/composables/useSuperAdminUser';
import { formatDateTimeWithoutSeconds } from '@/utils/utils';
import { onMounted, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Threads',
    setup(__props) {
        const { messages, totalCount, criteria, fetchThreads } = useMessageThread();
        const { superAdminUser, fetchSuperAdminUser } = useSuperAdminUser();
        const showMessageModal = ref(false);
        const fromUserId = ref(0);
        const toUserId = ref(0);
        onMounted(() => {
            fetchSuperAdminUser();
        });
        const initMessageModal = (_fromUserId, _toUserId) => {
            if (_fromUserId == superAdminUser.value?.id) {
                fromUserId.value = 0;
                toUserId.value = _toUserId;
            }
            else if (_toUserId == superAdminUser.value?.id) {
                fromUserId.value = 0;
                toUserId.value = _fromUserId;
            }
            else {
                fromUserId.value = _fromUserId;
                toUserId.value = _toUserId;
            }
            showMessageModal.value = true;
        };
        const searchThreads = () => {
            criteria.value.page = 1;
            fetchThreads();
        };
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_pagination = _resolveComponent("v-pagination");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createElementVNode("h2", null, "メッセージスレッド一覧", -1)
                                ])),
                                _: 1,
                                __: [8]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                                modelValue: _unref(criteria).adminFilter,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(criteria).adminFilter) = $event)),
                                inline: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_radio, {
                                        label: "すべて",
                                        value: "all"
                                    }),
                                    _createVNode(_component_v_radio, {
                                        label: "運営のみ",
                                        value: "onlyAdmin"
                                    }),
                                    _createVNode(_component_v_radio, {
                                        label: "運営を除く",
                                        value: "withoutAdmin"
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_btn, {
                                onClick: _cache[1] || (_cache[1] = ($event) => (searchThreads()))
                            }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode("検索")
                                ])),
                                _: 1,
                                __: [9]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_pagination, {
                                        modelValue: _unref(criteria).page,
                                        "onUpdate:modelValue": [
                                            _cache[2] || (_cache[2] = ($event) => ((_unref(criteria).page) = $event)),
                                            _cache[3] || (_cache[3] = ($event) => (_unref(fetchThreads)()))
                                        ],
                                        length: Math.ceil(_unref(totalCount) / _unref(criteria).pageSize)
                                    }, null, 8, ["modelValue", "length"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", {
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_unref(fetchThreads)()))
                                    }, [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                _createTextVNode("mdi-refresh")
                                            ])),
                                            _: 1,
                                            __: [10]
                                        })
                                    ]),
                                    _createVNode(_component_v_table, { density: "compact" }, {
                                        default: _withCtx(() => [
                                            _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", null, "送信ユーザー"),
                                                    _createElementVNode("td", null, "受信ユーザー"),
                                                    _createElementVNode("td", null, "最新メッセージ"),
                                                    _createElementVNode("td", null, "詳細")
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: message.id
                                                    }, [
                                                        _createElementVNode("td", null, [
                                                            _createTextVNode(_toDisplayString(message.fromUserBelongsTo), 1),
                                                            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                                            _createTextVNode(_toDisplayString(message.fromUserName), 1)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createTextVNode(_toDisplayString(message.toUserBelongsTo), 1),
                                                            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                                            _createTextVNode(_toDisplayString(message.toUserName), 1)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("p", _hoisted_1, _toDisplayString(message.text), 1),
                                                            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(formatDateTimeWithoutSeconds)(message.sentTime)), 1)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("span", {
                                                                onClick: ($event) => (initMessageModal(message.fromUserId, message.toUserId))
                                                            }, [
                                                                _createVNode(_component_v_icon, null, {
                                                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                        _createTextVNode("mdi-list-box-outline")
                                                                    ])),
                                                                    _: 1,
                                                                    __: [13]
                                                                })
                                                            ], 8, _hoisted_3)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ]),
                                        _: 1,
                                        __: [14]
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_pagination, {
                                        modelValue: _unref(criteria).page,
                                        "onUpdate:modelValue": [
                                            _cache[5] || (_cache[5] = ($event) => ((_unref(criteria).page) = $event)),
                                            _cache[6] || (_cache[6] = ($event) => (_unref(fetchThreads)()))
                                        ],
                                        length: Math.ceil(_unref(totalCount) / _unref(criteria).pageSize)
                                    }, null, 8, ["modelValue", "length"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (showMessageModal.value)
                        ? (_openBlock(), _createBlock(MessageModal, {
                            key: 0,
                            "from-user-id": fromUserId.value,
                            "to-user-id": toUserId.value,
                            onClose: _cache[7] || (_cache[7] = ($event) => (showMessageModal.value = false))
                        }, null, 8, ["from-user-id", "to-user-id"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
